import * as i0 from '@angular/core';
import { Directive, Component, ViewChild, Injectable, Optional, Input, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class InsertionDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: InsertionDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: InsertionDirective, selector: "[appInsertion]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: InsertionDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[appInsertion]',
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }] });

class DialogRef {
    constructor() {
        this._afterClosed = new Subject();
        this.afterClosed = this._afterClosed.asObservable();
        // noop
    }
    close(result) {
        this._afterClosed.next(result);
        this._afterClosed.complete();
    }
}

class DialogConfig {
    constructor() {
        this.closeOnOverlayClicked = false;
    }
}

class DialogComponent {
    constructor(componentFactoryResolver, cd, dialogRef, dialogConfig) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.cd = cd;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this._onClose = new Subject();
        this.onClose = this._onClose.asObservable();
    }
    ngAfterViewInit() {
        this.loadChildComponent(this.childComponentType);
        this.cd.detectChanges();
    }
    onOverlayClicked(evt) {
        if (this.dialogConfig.closeOnOverlayClicked) {
            this.dialogRef.close();
        }
    }
    onDialogClicked(evt) {
        evt.stopPropagation();
    }
    loadChildComponent(componentType) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
        const viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }
    close() {
        this._onClose.next();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogComponent, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ChangeDetectorRef }, { token: DialogRef }, { token: DialogConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.0.7", type: DialogComponent, selector: "app-dialog", viewQueries: [{ propertyName: "insertionPoint", first: true, predicate: InsertionDirective, descendants: true }], ngImport: i0, template: "<div class=\"overlay\" (click)=\"onOverlayClicked($event)\">\n  <div\n    class=\"dialog\"\n    (click)=\"onDialogClicked($event)\"\n    [ngStyle]=\"dialogConfig.style\"\n  >\n    <ng-template appInsertion> </ng-template>\n  </div>\n</div>\n", styles: [":host{position:fixed;z-index:9999}.overlay{position:fixed;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center}.dialog{box-shadow:0 14px 28px #00000040,0 10px 10px #00000038;background-color:#fff;max-width:65%;max-height:80%;overflow:auto;z-index:1001}@media screen and (max-width: 540px),screen and (max-height: 540px){.dialog{min-width:100%;max-width:100%;min-height:100%;max-height:100%}}::ng-deep .dialog>*{padding:12px;box-sizing:border-box;display:flex;flex-direction:column;max-height:100%;max-width:100%}::ng-deep dialog-title{margin:12px 0;flex:0 0 auto}::ng-deep dialog-content{margin:12px 0;flex:1 1 auto;overflow:auto}::ng-deep dialog-actions{margin:12px 0;flex:0 0 auto}\n"], dependencies: [{ kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: InsertionDirective, selector: "[appInsertion]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-dialog', template: "<div class=\"overlay\" (click)=\"onOverlayClicked($event)\">\n  <div\n    class=\"dialog\"\n    (click)=\"onDialogClicked($event)\"\n    [ngStyle]=\"dialogConfig.style\"\n  >\n    <ng-template appInsertion> </ng-template>\n  </div>\n</div>\n", styles: [":host{position:fixed;z-index:9999}.overlay{position:fixed;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center}.dialog{box-shadow:0 14px 28px #00000040,0 10px 10px #00000038;background-color:#fff;max-width:65%;max-height:80%;overflow:auto;z-index:1001}@media screen and (max-width: 540px),screen and (max-height: 540px){.dialog{min-width:100%;max-width:100%;min-height:100%;max-height:100%}}::ng-deep .dialog>*{padding:12px;box-sizing:border-box;display:flex;flex-direction:column;max-height:100%;max-width:100%}::ng-deep dialog-title{margin:12px 0;flex:0 0 auto}::ng-deep dialog-content{margin:12px 0;flex:1 1 auto;overflow:auto}::ng-deep dialog-actions{margin:12px 0;flex:0 0 auto}\n"] }]
        }], ctorParameters: () => [{ type: i0.ComponentFactoryResolver }, { type: i0.ChangeDetectorRef }, { type: DialogRef }, { type: DialogConfig }], propDecorators: { insertionPoint: [{
                type: ViewChild,
                args: [InsertionDirective, { static: false }]
            }] } });

class DialogInjector {
    constructor(_parentInjector, _additionalTokens) {
        this._parentInjector = _parentInjector;
        this._additionalTokens = _additionalTokens;
    }
    get(token, notFoundValue, flags) {
        const value = this._additionalTokens.get(token);
        if (value)
            return value;
        return this._parentInjector.get(token, notFoundValue);
    }
}

class DialogService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    static { this.dialogs = []; }
    static closeAll() {
        for (const dialog of this.dialogs) {
            if (dialog) {
                dialog.close();
            }
            this.dialogs = this.dialogs.filter((obj) => obj !== dialog);
        }
    }
    open(componentType, config) {
        const dialogRef = this.appendDialogComponentToBody(config);
        this.dialogComponentRef.instance.childComponentType = componentType;
        return dialogRef;
    }
    appendDialogComponentToBody(config) {
        const map = new WeakMap();
        map.set(DialogConfig, config);
        const dialogRef = new DialogRef();
        map.set(DialogRef, dialogRef);
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
        const componentRef = componentFactory.create(new DialogInjector(this.injector, map));
        this.appRef.attachView(componentRef.hostView);
        const domElem = componentRef.hostView
            .rootNodes[0];
        document.body.appendChild(domElem);
        this.dialogComponentRef = componentRef;
        const sub = dialogRef.afterClosed.subscribe(() => {
            this.removeDialogComponentFromBody(componentRef);
            sub.unsubscribe();
            DialogService.dialogs = DialogService.dialogs.filter((obj) => obj !== dialogRef);
        });
        this.dialogComponentRef.instance.onClose.subscribe(() => {
            this.removeDialogComponentFromBody(componentRef);
        });
        DialogService.dialogs.push(dialogRef);
        return dialogRef;
    }
    removeDialogComponentFromBody(componentRef) {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogService, providedIn: 'any' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'any',
                }]
        }], ctorParameters: () => [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }] });

/** Counter used to generate unique IDs for dialog elements. */
let dialogElementUid = 0;
/**
 * Button that will close the current dialog.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class DialogClose {
    constructor(dialogRef, _elementRef, _dialog) {
        this.dialogRef = dialogRef;
        this._elementRef = _elementRef;
        this._dialog = _dialog;
        /** Default to "button" to prevents accidental form submits. */
        this.type = 'button';
    }
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit() {
        // noop
    }
    ngOnChanges(changes) {
        const proxiedChange = changes._matDialogClose || changes._matDialogCloseResult;
        if (proxiedChange) {
            this.dialogResult = proxiedChange.currentValue;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogClose, deps: [{ token: DialogRef, optional: true }, { token: i0.ElementRef }, { token: DialogComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: DialogClose, selector: "[dialog-close], [dialogClose]", inputs: { ariaLabel: ["aria-label", "ariaLabel"], type: "type", dialogResult: ["dialog-close", "dialogResult"], _matDialogClose: ["dialogClose", "_matDialogClose"] }, host: { listeners: { "click": "dialogRef.close(dialogResult)" }, properties: { "attr.aria-label": "ariaLabel || null", "attr.type": "type" } }, exportAs: ["dialogClose"], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogClose, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[dialog-close], [dialogClose]',
                    exportAs: 'dialogClose',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '(click)': 'dialogRef.close(dialogResult)',
                        '[attr.aria-label]': 'ariaLabel || null',
                        '[attr.type]': 'type',
                    },
                }]
        }], ctorParameters: () => [{ type: DialogRef, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: DialogComponent }], propDecorators: { ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], type: [{
                type: Input
            }], dialogResult: [{
                type: Input,
                args: ['dialog-close']
            }], _matDialogClose: [{
                type: Input,
                args: ['dialogClose']
            }] } });
/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class DialogTitle {
    constructor(_dialogRef, _elementRef, _dialog) {
        this._dialogRef = _dialogRef;
        this._elementRef = _elementRef;
        this._dialog = _dialog;
        this.id = `dialog-title-${dialogElementUid++}`;
    }
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit() {
        // noop
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogTitle, deps: [{ token: DialogRef, optional: true }, { token: i0.ElementRef }, { token: DialogComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: DialogTitle, selector: "[dialog-title], dialog-title, [dialogTitle]", inputs: { id: "id" }, host: { properties: { "id": "id" }, classAttribute: "dialog-title" }, exportAs: ["dialogTitle"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogTitle, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[dialog-title], dialog-title, [dialogTitle]',
                    exportAs: 'dialogTitle',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        class: 'dialog-title',
                        '[id]': 'id',
                    },
                }]
        }], ctorParameters: () => [{ type: DialogRef, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: DialogComponent }], propDecorators: { id: [{
                type: Input
            }] } });
/**
 * Scrollable content container of a dialog.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class DialogContent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogContent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: DialogContent, selector: "[dialog-content], dialog-content, [dialogContent]", host: { classAttribute: "dialog-content" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogContent, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: `[dialog-content], dialog-content, [dialogContent]`,
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: { class: 'dialog-content' },
                }]
        }] });
/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class DialogActions {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogActions, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.7", type: DialogActions, selector: "[dialog-actions], dialog-actions, [dialogActions]", host: { classAttribute: "dialog-actions" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogActions, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: `[dialog-actions], dialog-actions, [dialogActions]`,
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: { class: 'dialog-actions' },
                }]
        }] });

class DialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.7", ngImport: i0, type: DialogModule, declarations: [DialogComponent,
            InsertionDirective,
            DialogTitle,
            DialogContent,
            DialogActions,
            DialogClose], imports: [CommonModule], exports: [DialogTitle, DialogContent, DialogActions, DialogClose] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        DialogComponent,
                        InsertionDirective,
                        DialogTitle,
                        DialogContent,
                        DialogActions,
                        DialogClose,
                    ],
                    exports: [DialogTitle, DialogContent, DialogActions, DialogClose],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DialogActions, DialogClose, DialogComponent, DialogConfig, DialogContent, DialogModule, DialogRef, DialogService, DialogTitle };
